import { render, staticRenderFns } from "./pickup-detail.vue?vue&type=template&id=124e5ac4&scoped=true&"
import script from "./pickup-detail.vue?vue&type=script&lang=js&"
export * from "./pickup-detail.vue?vue&type=script&lang=js&"
import style0 from "./pickup-detail.vue?vue&type=style&index=0&id=124e5ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e5ac4",
  null
  
)

export default component.exports